module.exports = __webpack_public_path__ + "img/shelleypitching.6df43aa3.jpg";